import { Component } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { environment } from 'src/environments/environment';
import { QrObrasExportService } from '../../services/qr-obras-export.service';

@Component({
  selector: 'app-obras-admin-exportar',
  templateUrl: './obras-admin-exportar.component.html',
  styleUrls: ['./obras-admin-exportar.component.scss']
})
export class ObrasAdminExportarComponent extends BaseListComponent<any> {

  serverUrl: string;

  constructor(
    private myService: QrObrasExportService
  ) {
    super()
  }

  ngOnInit() {
    this.serverUrl = environment.serverUrl;
    this.loaded();
  }

  export(id: number): void {
    this.loading();

    this.myService.getExportFile(id).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'export.csv';
        a.click();

        window.URL.revokeObjectURL(url);
        this.loaded();
      },
      error: (error) => {
				this.msgError(error?.message);
        this.loaded();
      }
    });
  }

}
